<template>
  <div class="services--form">
    <BaseAlert
      v-if="serviceGroups.length < 1"
      :hg-value="true"
      hg-type="warning"
      ref="services-error">
      No Services available for selected Inspector.
      Click Continue to move forward with the scheduling process.
    </BaseAlert>

    <FormContainer :submit="onSubmit" class="services--form">
      <section class="services--form-groups">
        <ServicesFormGroup
          v-for="serviceGroup in serviceGroups"
          :key="serviceGroup.id"
          :selected-services="form.selectedServices"
          :service-group="serviceGroup"
          @toggleService="toggleService"
          @updateQuantity="updateQuantity" />
      </section>
      <StepNavigation submit-mode @save="save" @submit="onSubmit" />
    </FormContainer>
  </div>
</template>

<script>
import { Components } from '@homegauge/vue';

import FormContainer from '@/components/FormContainer.vue';
import ServicesFormGroup from '@/components/ServicesFormGroup.vue';
import StepNavigation from '@/components/StepNavigation.vue';
import FormMixin from '@/mixins/FormMixin';

const { BaseAlert } = Components;

export default {
  components: {
    BaseAlert,
    FormContainer,
    ServicesFormGroup,
    StepNavigation,
  },
  inject: ['$validator'],
  mixins: [FormMixin],
  props: {
    model: {
      type: Array,
      default: () => [],
    },
    serviceGroups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        selectedServices: [],
      },
    };
  },
  methods: {
    hydrateForm(model) {
      this.form.selectedServices = model;
    },
    async onSubmit() {
      const formIsValid = await this.validateForm(true);
      if (formIsValid) {
        this.$emit('submit', this.form.selectedServices);
      }
    },
    save() {
      this.$emit('save', this.form.selectedServices);
    },
    toggleService(serviceId) {
      const selectedServices = this.form.selectedServices.slice();
      const serviceIndex = selectedServices.findIndex(service => service.id === serviceId);

      if (serviceIndex > -1) {
        selectedServices.splice(serviceIndex, 1);
      } else {
        selectedServices.push({
          id: serviceId,
          quantity: 1,
        });
      }
      this.updateServices(selectedServices);
    },
    updateQuantity(servicePayload) {
      const selectedServices = this.form.selectedServices.slice();
      const serviceIndex = selectedServices
        .findIndex(service => service.id === servicePayload.id);

      if (serviceIndex > -1) {
        selectedServices[serviceIndex].quantity = servicePayload.quantity || 0;
      }
      this.updateServices(selectedServices);
    },
    updateServices(updatedServices) {
      this.$set(this.form, 'selectedServices', updatedServices);
      this.save();
    },
  },
  watch: {
    model: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.hydrateForm(newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';

.services--form {
  &-groups {
    padding: 30px 0 0;
  }
}

@include responsive-breakpoint(sm) {
  .services--form {
    &-groups {
      padding: 0;
    }
  }
}
</style>
